export default __webpack_public_path__ + "static/media/flag-syrian-arab-republic.339f6c89.svg";